import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { groupColor, INK, MUTED } from 'client/modules/Analyze/analyzeTheme';
import PropTypes from 'prop-types';
import React from 'react';

const SIZE = 180;
const STROKE = 26;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

// Donut chart of score-group composition with the headline score in the center.
function ScoreGroupsDonut({ groups, order, total, scoreLabel, displayScore, formatNumber }) {
  let offset = 0;
  const segments = order
    .map(group => {
      const count = groups?.[group] ?? 0;
      const fraction = total > 0 ? count / total : 0;
      const segment = {
        group,
        color: groupColor(group),
        dash: fraction * CIRCUMFERENCE,
        offset,
      };
      offset += fraction * CIRCUMFERENCE;
      return segment;
    })
    .filter(s => s.dash > 0);

  return (
    <Box sx={{ position: 'relative', width: SIZE, height: SIZE, flexShrink: 0 }}>
      <Box
        component="svg"
        width={SIZE}
        height={SIZE}
        viewBox={`0 0 ${SIZE} ${SIZE}`}
        sx={{ transform: 'rotate(-90deg)' }}
      >
        <circle
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={RADIUS}
          fill="none"
          stroke="#EEF1F5"
          strokeWidth={STROKE}
        />
        {segments.map(s => (
          <circle
            key={s.group}
            cx={SIZE / 2}
            cy={SIZE / 2}
            r={RADIUS}
            fill="none"
            stroke={s.color}
            strokeWidth={STROKE}
            strokeDasharray={`${s.dash} ${CIRCUMFERENCE - s.dash}`}
            strokeDashoffset={-s.offset}
          />
        ))}
      </Box>
      {displayScore != null && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography sx={{ fontSize: 13, fontWeight: 600, color: MUTED, letterSpacing: '.5px' }}>
            {scoreLabel}
          </Typography>
          <Typography
            sx={{
              fontSize: 44,
              fontWeight: 800,
              color: INK,
              lineHeight: 1,
              letterSpacing: '-1.5px',
            }}
          >
            {formatNumber(displayScore)}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

ScoreGroupsDonut.propTypes = {
  groups: PropTypes.object,
  order: PropTypes.arrayOf(PropTypes.string).isRequired,
  total: PropTypes.number.isRequired,
  scoreLabel: PropTypes.string.isRequired,
  displayScore: PropTypes.number,
  formatNumber: PropTypes.func.isRequired,
};

export default ScoreGroupsDonut;
